import { render, staticRenderFns } from "./MarketExchangePrizse.vue?vue&type=template&id=1f4fec30&scoped=true&"
import script from "./MarketExchangePrizse.vue?vue&type=script&lang=js&"
export * from "./MarketExchangePrizse.vue?vue&type=script&lang=js&"
import style0 from "./MarketExchangePrizse.vue?vue&type=style&index=0&id=1f4fec30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4fec30",
  null
  
)

export default component.exports